module.exports = __webpack_public_path__ + "img/tron (61).151d720e.jpg";